import { useNavigate, useParams } from 'react-router-dom';
import Page from 'src/components/Page';
import { FormProvider, useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { yupResolver } from '@hookform/resolvers/yup';
import { styledMainTitle } from 'src/components/InviteModal/styles';
import { Box, Button, Typography } from '@mui/material';
import RHFDatePicker from 'src/components/hook-form/RHFDatePicker';
import { ActionButtons } from 'src/layouts/main/styles';
import { LoadingButton } from '@mui/lab';
import confirmTransactionDates from 'src/api/transaction/confirm-transaction-dates';
import { validationSchema } from './validation';
import { ConfirmTransactionDatesForm } from './types';
import { AuthPage } from '../auth/styles';

const ConfirmTransactionDates = () => {
	const navigate = useNavigate();
	const { enqueueSnackbar } = useSnackbar();
	const { id } = useParams();
	const form = useForm<ConfirmTransactionDatesForm>({
		resolver: yupResolver(validationSchema),
		defaultValues: {
			completionDate: new Date(),
			exchangeDate: new Date(),
		},
	});

	const handleLogin = () => navigate('/auth/login');

	const handleSubmit = async (data: ConfirmTransactionDatesForm) => {
		try {
			if (!id) return;

			await confirmTransactionDates({ id, ...data });

			handleLogin();
		} catch (e) {
			if (e instanceof Error) enqueueSnackbar(e.message, { variant: 'error' });
		}
	};

	return (
		<Page title='Quote'>
			<AuthPage>
				<FormProvider {...form}>
					<form onSubmit={form.handleSubmit(handleSubmit)}>
						<Box
							display='flex'
							flexDirection='column'
							gap='15px'
							maxWidth='750px'
							minWidth='750px'
							sx={{ background: 'white' }}
							p='15px'
							borderRadius='8px'
						>
							<Typography sx={styledMainTitle} pt={0}>
								SELECT TRANSACTION EXCHANGE AND COMPLETION DATES
							</Typography>
							<RHFDatePicker name='exchangeDate' label='Exchange Date' />
							<RHFDatePicker name='completionDate' label='Completion Date' />
							<ActionButtons mt={'20px'}>
								<Button fullWidth onClick={handleLogin} variant='outlined'>
									Cancel
								</Button>
								<LoadingButton variant='contained' fullWidth type='submit' loading={form.formState.isSubmitting}>
									Submit
								</LoadingButton>
							</ActionButtons>
						</Box>
					</form>
				</FormProvider>
			</AuthPage>
		</Page>
	);
};

export default ConfirmTransactionDates;
